// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"470.754\" height=\"472.345\" viewBox=\"-206.335 -206.723 470.754 472.345\"><path fill=\"#fff\" d=\"M-206.335-206.723h470.754v472.345h-470.754z\"/><path fill=\"#e8423f\" d=\"M-206.335-206.723h470.754V29.453h-470.754z\"/></svg>";
// Exports
module.exports = code;